import { ValueOf } from "shared/lib/typeCheck.lib";

/** MapLibre style keys on map.qubictron.com */
export const MapThemeStyle = {
  DARK: "dark",
  LIGHT: "light",
} as const;

export type MapThemeStyleValue = ValueOf<typeof MapThemeStyle>;

/** UI labels: Light = basic map, Dark = night map */
export const MapThemeUi = {
  LIGHT: "light",
  DARK: "dark",
} as const;

export type MapThemeUiValue = ValueOf<typeof MapThemeUi>;

export const DEFAULT_MAP_THEME = MapThemeStyle.DARK;

export const MAP_STYLE_URL: Record<MapThemeStyleValue, string> = {
  [MapThemeStyle.DARK]: "https://map.qubictron.com/styles/night/style.json",
  [MapThemeStyle.LIGHT]: "https://map.qubictron.com/styles/basic/style.json",
};

export const mapThemeFromUi = (ui: MapThemeUiValue): MapThemeStyleValue =>
  ui === MapThemeUi.LIGHT ? MapThemeStyle.LIGHT : MapThemeStyle.DARK;

export const mapUiFromTheme = (theme: MapThemeStyleValue): MapThemeUiValue =>
  theme === MapThemeStyle.LIGHT ? MapThemeUi.LIGHT : MapThemeUi.DARK;

export const isMapThemeStyle = (value: string | null): value is MapThemeStyleValue =>
  value === MapThemeStyle.DARK || value === MapThemeStyle.LIGHT;
